import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { formatDecimalNumber, formatUSD } from '../../helpers/helperFunctions';
import { CaptionText, H3, P1, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioWallet
} from '../../styles/Icons';
import { settingsInit } from '../Settings/Settings.actions';

import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';
import { WithdrawAvailability, WithdrawSteps } from './Portfolio.types';
import { Wallet } from './Wallet';
import { Withdraw } from './Withdraw/Withdraw';

export const WalletSummary = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('my_hubs');

  const [step, setStep] = useState<WithdrawSteps>(WithdrawSteps.INITIAL);
  const [withdraw, setWithdraw] = useState(false);
  const [withdrawAvailabilitySteps, setWithdrawAvailabilitySteps] = useState(
    WithdrawAvailability.ULX
  );

  const { walletSummary, withdrawAvailability } = useAppSelector(
    (state) => state.portfolio
  );

  return (
    <>
      <Flexed mb='20' between alignEnd rowSM alignStartSM gap='16px'>
        <H3 color={colors.neutral900}>{t('my_wallet_summary')}</H3>
        <Wallet />
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_personal_orders')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(walletSummary?.totalOrder)} <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
        {/* 
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioDistribution />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_orders_with_autostake_intact')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(walletSummary?.totalOrderAutostakeIntact)}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio> */}

        <BoxPortfolio hasButton>
          <Flexed center>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioWallet />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('available_in_wallet')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(walletSummary?.availableBalance)}
                <P3 mb='1'>wULX</P3>
              </P1>
            </div>
          </Flexed>
          <Button
            w='100px'
            h='34px'
            disabled={walletSummary && walletSummary?.availableBalance < 1}
            onClick={() => {
              setWithdrawAvailabilitySteps(WithdrawAvailability.ULX);
              if (withdrawAvailability?.isAvailable) {
                setWithdraw(true);
                setStep(1);
                dispatch(settingsInit());
              } else {
                setWithdraw(true);
                setStep(9);
              }
            }}>
            {t('withdraw')}
          </Button>
        </BoxPortfolio>

        <BoxPortfolio hasButton>
          <Flexed center>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioWallet />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('available_in_wallet')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatDecimalNumber(
                  walletSummary?.availableUsdtToWithdraw
                    ? walletSummary?.availableUsdtToWithdraw
                    : 0
                )}
                <P3 mb='1'>uUSDT</P3>
              </P1>
            </div>
          </Flexed>

          <Button
            w='100px'
            h='34px'
            disabled={
              walletSummary && walletSummary?.availableUsdtToWithdraw < 1
            }
            onClick={() => {
              setWithdrawAvailabilitySteps(WithdrawAvailability.USDT);
              if (withdrawAvailability?.isAvailable) {
                setWithdraw(true);
                setStep(1);
                dispatch(settingsInit());
              } else {
                setWithdraw(true);
                setStep(9);
              }
            }}>
            {t('withdraw')}
          </Button>
        </BoxPortfolio>
      </SummaryGrid>

      <SidebarModal
        isOpen={withdraw}
        setOpen={setWithdraw}
        title={`${
          withdrawAvailabilitySteps === WithdrawAvailability.ULX
            ? 'wULX'
            : 'uUSDT'
        } ${t('withdrawal')}`}
        sidebarWidth={'508px'}>
        <Withdraw
          step={step}
          setStep={setStep}
          setWithdraw={setWithdraw}
          withdrawAvailabilitySteps={withdrawAvailabilitySteps}
        />
      </SidebarModal>
    </>
  );
};
